<template lang="pug">
  #profile-menu
    #pm-avatar(ref="pmavatar" @click="toggle")
      img(:src="$auth.user().image" v-if="$auth.ready()" )

    #pm-actions(ref="pmmenu" v-if="active" v-closeable="{exclude: ['pmavatar'] ,handler: 'toggle'}")
      .pm-action(@click="gotoProfile") Profile
      .pm-action(@click="gotoVisited") Visited
      .pm-action(@click="gotoSettings") Settings
      .pm-action(@click="gotoBlocks") Blocked Users

      template(v-if="$breakpoint.isTouch")
        RouterLink.pm-action(:to="{name: 'privacy'}"  target="_blank") Privacy
        RouterLink.pm-action(:to="{name: 'tos'}" target="_blank") Terms
        RouterLink.pm-action(:to="{name: 'about'}" target="_blank") About

      .pm-action-divid
      .pm-action(@click="logout") Logout
  </template>

<script>
export default {
  props: {},

  data() {
    return {
      active: false,
    }
  },

  computed: {},

  watch: {},

  methods: {
    gotoBlocks,
    gotoProfile,
    gotoSettings,
    gotoVisited,
    logout,
    toggle,
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
function gotoBlocks() {
  this.toggle()

  if (this.$route.name != 'blocks') {
    this.$router.push({ name: 'blocks' })
  }
}

function gotoSettings() {
  this.toggle()

  if (this.$route.name != 'userSettings') {
    this.$router.push({ name: 'userSettings' })
  }
}

function gotoProfile() {
  this.toggle()

  if (this.$route.params.slug != this.$app.user.username) {
    this.$router.push({ name: 'peopleShow', params: { slug: this.$app.user.username } })
  }
}

function logout() {
  this.$auth.logout({ redirect: { name: 'login' } })
}

function gotoVisited() {
  this.toggle()

  if (this.$route.name != 'visitedIndex') {
    this.$router.push({ name: 'visitedIndex' })
  }
}

function toggle() {
  this.active = !this.active
}
</script>
